import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ResourceInfoPopover from '../../common/ResourceInfoPopover';
import { TruncatedTitle } from '../../common/TruncatedTitle';
import { RESOURCE_LABEL } from '../../common/constants';

function SummaryHeader({ summary, onCopy }) {
  const navigate = useNavigate();

  return (
    <Box className="resourceHeader" id="summaryDetails__box_header">
      <Box className="resourceTitleGroup">
        <Box className="resourceTitle">
          <TruncatedTitle
            id="summaryDetails__text_title"
            variant="h2"
            component="h1"
            name={summary.title}
          />
          <ResourceInfoPopover
            id="summaryDetails__button_info"
            name={summary.title}
            nameLabel={RESOURCE_LABEL.SUMMARY_NOTES}
            resources={summary.resources}
            lastEditedBy={summary.lastEditedBy}
          />
        </Box>
      </Box>

      <Box className="resourceActions resourceActions--stack">
        <Button
          variant="contained"
          className="mss__button"
          id="summaryDetails__button_edit"
          onClick={() => navigate('edit')}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          className="mss__button primary"
          id="summaryDetails__button_copy"
          onClick={onCopy}
        >
          Copy
        </Button>
      </Box>
    </Box>
  );
}

export default SummaryHeader;
